<template>
  <div
    id="mainApp"
    class="container-fluid"
  >

    <!--    <mobile-header></mobile-header>-->
    <catergory-nav-mobile />
    <mobile-header-sticky v-if="$route.path ==='/' && screenWidth < 991"/>
    <!-- <top-header v-if="!$route.path.includes('vendor')"></top-header> -->
    <header-nav-tab v-if="(!$route.path.includes('vendor') &&
                           !$route.path.includes('agent') &&
                           !$route.path.includes('tenant') &&
                          ((screenWidth < 991 && $route.path ==='/')||
                          (screenWidth > 991)) &&
                          (!$route.path.includes('login') &&
                          !$route.path.includes('signup')&&
                          !$route.path.includes('reset-password')&&
                          !$route.path.includes('forgotPassword')))"
				/>
    <!--<header-nav-tab-two v-if="$route.path.includes('reset-password')||-->
    <!--$route.path.includes('forgotPassword')"-->
    <!--/>-->
			<header-nav-tab-three v-if="$route.path.includes('vendor') ||
                                $route.path.includes('agent')||
                                $route.path.includes('tenant')||
                                $route.path.includes('login') ||
                                $route.path.includes('signup') ||
                                $route.path.includes('reset-password') ||
                                $route.path.includes('forgotPassword')"
			/>
    <mobile-header-back v-if="!$route.path.includes('vendor')&&
                              !$route.path.includes('agent')&&
                              !$route.path.includes('tenant')&&
                              !$route.path.includes('login') &&
                              !$route.path.includes('signup')&&
                              !$route.path.includes('reset-password')&&
                              !$route.path.includes('forgotPassword')&&
                              screenWidth < 991 &&
                              $route.path !=='/'" />
    <category-nav-bar v-if="!$route.path.includes('vendor') &&
                            !$route.path.includes('agent') &&
                            !$route.path.includes('tenant') &&
                            !$route.path.includes('login') &&
                            !$route.path.includes('signup')&&
                            !$route.path.includes('reset-password')&&
                            !$route.path.includes('forgotPassword')" />
    <router-view :key="$route.path" />
    <site-footer v-if="(screenWidth < 991 &&
                        $route.path ==='/')||
                        (screenWidth > 991)" />
  </div>
</template>
<script>
import HeaderNavTab from '@/components/shared/headers/HeaderNavTab'
import HeaderNavTabThree from '@/components/shared/headers/HeaderNavTabThree'
import MobileHeaderBack from '@/components/shared/headers/mobile/MobileHeaderBack'
import CategoryNavBar from '@/components/shared/categoryNavBar/CategoryNavBar'
import MobileHeaderSticky from '@/components/shared/headers/mobile/mobileHeaderSticky'
import CatergoryNavMobile from '@/components/shared/categoryNavBar/mobile/CatergoryNavMobile'
import SiteFooter from '@/components/shared/footer/Footer'
import { mapActions, mapGetters } from 'vuex'
import { productApi } from '@/services/ApiServices/productApi'
import { cartApis } from '@/services/ApiServices/cartApis'
import { customerApi } from '../services/ApiServices/customerApi'
import { ripple } from '../assets/js/ripple'

// import CartIntraction from '@/components/shared/categoryNavBar/modals/CartIntraction';
export default {
	async beforeMount () {
		// if (this.isAuthenticated) {
		//   customerApi.checkLoginStatus();
		// }
		this.isLoading = true
		try {
			await customerApi.getTenantConfigurations()
			await productApi.getCategories()
			this.isLoading = false
		} catch (err) {
			// this.isLoading = false;
		}
		this.setSortData({ sortOrder: 'ASC', sortMethod: 'NAME' })
	},
	mounted () {
		this.screenWidth = screen.width
		this.setScreenWidthData(this.screenWidth)
		$('#icon-count-btn').on('click', () => {
			$('body').toggleClass('stop-scroll')
		})
		// if (this.isAuthenticated) {
		this.hai()
		if (this.isAuthenticated) {
			this.isLoading = true
			customerApi.getCustomerDetails()
			cartApis.getCart().then(() => {
				this.isLoading = false
			})
		}
		setInterval(this.hai, 50000)
		// }
		ripple.ripples()
		// this.pageScroll();
		window.onload = function () {
			if (screen.width < 992 && navigator.userAgent.includes('wv')) {
				Android.onLoadComplete()
			}
		}
		// const android = /Android/i.test(navigator.userAgent)
		// const ios = /iPhone|iPad|iPod/i.test(navigator.userAgent);
		// const andriod = /Android/i.test(navigator.userAgent);
		// if (andriod) {
		//   alert('Android');
		// }
		//
	},
	computed: {
		...mapGetters('user', ['isAuthenticated'])
	},
	components: {
		HeaderNavTab,
		CategoryNavBar,
		SiteFooter,
		CatergoryNavMobile,
		MobileHeaderSticky,
		MobileHeaderBack,
		HeaderNavTabThree
	},
	data () {
		return {
			screenWidth: 0,
			isLoading: true,
			fullPage: true,
			bool: ''
		}
	},
	watch: {
		$route () {
			// this.pageScroll();
		},
		'screen.width': function () {
			this.screenWidth = screen.width
			this.setScreenWidthData(this.screenWidth)
			// this.pageScroll();
		}
	},
	methods: {
		...mapActions('filters', ['setSortData']),
		...mapActions('siteData', ['setScreenWidthData']),
		async hai () {
			if (this.isAuthenticated) {
				// await customerApi.checkLoginStatus();
			}
		},
		pageScroll () {
			if (screen.width >= 476) {
				let prevScrollpos = window.pageYOffset
				window.onscroll = function () {
					const currentScrollPos = window.pageYOffset
					if ((prevScrollpos > currentScrollPos) && document.getElementById('wp_CategoryNav') && document.getElementById('wp_CategoryNav').style) {
						document.getElementById('wp_CategoryNav').style.top = '59px'
					} else if (document.getElementById('wp_CategoryNav') && document.getElementById('wp_CategoryNav').style) {
						document.getElementById('wp_CategoryNav').style.top = '0'
					}
					prevScrollpos = currentScrollPos
				}
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid blue;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: blue transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.vld-overlay.is-full-page {
  z-index: 2999 !important;
}
</style>
